import { Invoice } from '../model/invoice';

import angular from 'angular';
import moment from 'moment';

angular
  .module('cxInvoicing')
  .controller('InvoicePaymentDialogCtrl', [
    '$element',
    'invoicingSvc',
    'transactionHttpSvc',
    'dataCache',
    'flySvc',
    '$filter',
    'openIbanSvc',
    'close',
    'invoice',
    'transaction',
    'appUrls',
    '$http',
    invoicePaymentDialogCtrl,
  ]);

function invoicePaymentDialogCtrl(
  $element,
  invoicingSvc,
  transactionHttpSvc,
  dataCache,
  flySvc,
  $filter,
  openIbanSvc,
  close,
  invoice,
  transaction,
  appUrls,
  $http,
) {
  var vm = this;
  if (!invoice || !invoice.id) {
    console.error('Invoice required');
    return;
  }

  vm.saving = false;
  vm.showValidation = false;
  vm.titleType = !transaction || !transaction.id ? 0 : 1;
  vm.paymentType = 0;
  vm.invoice = invoice;
  if (vm.invoice && !(vm.invoice instanceof Invoice)) vm.invoice = new Invoice(vm.invoice);

  vm.documents = null;
  vm.document = null;
  vm.bankAccounts = [];
  vm.transaction = transaction;

  const getCompanyBankAccounts = () => {
    $http
      .get(`${appUrls.api}/api/company/${invoice.companyId}/bankaccounts`)
      .then(({ data }) => {
        vm.bankAccounts = data;

        const mainBankAccount = data.find(x => x.isMain);

        if (mainBankAccount) {
          vm.transaction.companyIBAN = mainBankAccount.bankAccountNr;
        }
      })
      .catch(error => flySvc.error(error));
  };

  function calcAmount() {
    if (vm.paymentType === 0) {
      if (!vm.transaction || !vm.transaction.id) return vm.invoice.dueAmount();
      return Math.abs(vm.invoice.dueAmount()) < Math.abs(vm.transaction.openAmount())
        ? vm.invoice.dueAmount()
        : vm.transaction.openAmount();
    } else {
      if (!vm.document || !vm.document.id) return vm.invoice.dueAmount();
      return Math.abs(
        Math.abs(vm.invoice.dueAmount()) < Math.abs(vm.document.dueAmount())
          ? vm.invoice.dueAmount()
          : vm.document.dueAmount(),
      );
    }
  }
  vm.payment = {
    invoiceId: invoice.id,
    amount: calcAmount().round(2),
    remark: '',
  };

  if (vm.transaction && vm.transaction.id) {
    vm.payment.remark = vm.transaction.description;
  } else {
    vm.transaction = {
      date: moment
        .utc()
        .startOf('day')
        .toDate(),
      iban: '',
      bic: '',
    };
    getCompanyBankAccounts();
  }

  if (typeof vm.transaction.date === 'string')
    vm.transaction.date = new moment(vm.transaction.date).toDate();

  vm.changePaymentType = function(type) {
    vm.paymentType = type;
    if (type === 1 && vm.documents === null) {
      transactionHttpSvc.getLinkableDocs(vm.invoice.id).then(
        function(data) {
          vm.documents =
            data.map(function(d) {
              return new Invoice(d);
            }) || [];
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
        },
      );
    }
    vm.payment.amount = calcAmount().round(2);
  };

  function createPayment() {
    vm.payment.invoiceId = vm.invoice.id;
    transactionHttpSvc.createPayment(vm.transaction.id, vm.payment).then(
      function(result) {
        if (result) {
          if (vm.transaction) vm.transaction.payments.push(result);
        }
        $element.modal('hide');
        close(result, 500);
        vm.saving = false;
      },
      function(error) {
        flySvc.error(error.data.code, error.data.parameters);
        vm.saving = false;
      },
    );
  }

  vm.save = function() {
    if (vm.saving) return;
    vm.saving = true;
    if (vm.paymentType === 0) {
      if (vm.transaction.id) {
        createPayment();
        return;
      }

      vm.transaction.amount = vm.payment.amount;
      vm.transaction.name = vm.invoice.customer.displayName;
      vm.transaction.description =
        vm.invoice.number + (vm.payment.remark ? ':' + vm.payment.remark : '');
      vm.transaction.source = 0;

      transactionHttpSvc.createTransaction(vm.transaction).then(
        function(data) {
          vm.transaction = data;
          createPayment();
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          vm.saving = false;
        },
      );
    } else {
      vm.payment.invoiceId = vm.invoice.id;
      transactionHttpSvc.createLink(vm.document.id, vm.payment).then(
        function(result) {
          vm.saving = false;
          $element.modal('hide');
          close(result, 500);
        },
        function(error) {
          flySvc.error(error.data.code, error.data.parameters);
          vm.saving = false;
        },
      );
    }
  };

  vm.cancel = function() {
    close(null, 500);
  };
  vm.getBic = function() {
    if (!vm.transaction || !vm.transaction.iban) return;
    openIbanSvc.getBic(vm.transaction.iban).then(
      function(bic) {
        if (bic) vm.transaction.bic = bic;
      },
      function(error) {
        if (error && error.code) flySvc.error(error.code, error.parameters);
      },
    );
  };

  vm.documentLabel = function(item) {
    return (
      item.number +
      '    (' +
      $filter('formatDate')(item.date) +
      ')    ' +
      $filter('translate')('Invoice Total') +
      ': ' +
      $filter('number')(item.amount, 2) +
      '    ' +
      $filter('translate')('Balance') +
      ': ' +
      $filter('number')(item.dueAmount(), 2)
    );
  };

  vm.documentChanged = function() {
    if (!vm.document || !vm.document.id) return;
    if (!(vm.document instanceof Invoice)) vm.document = new Invoice(vm.document);
    vm.payment.amount = calcAmount().round(2);
    vm.payment.remark = vm.document.number;
  };
}
